import { serializeTaskView } from './taskViewRequest';

const newRequestKey = () =>
  globalThis.crypto?.randomUUID?.() ||
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;

// Mesma chave para o mesmo conteúdo até a criação ser confirmada. Se o POST
// gravou e a resposta se perdeu, o reenvio manual devolve a pasta (ou o
// segmento) que o servidor já criou, em vez de gravar outra igual.
export const createCustomViewRequestKeys = () => {
  const keys = new Map();
  return {
    withKey(payload) {
      const signature = serializeTaskView(payload);
      if (!keys.has(signature)) keys.set(signature, newRequestKey());
      return { ...payload, request_key: keys.get(signature) };
    },
    // depois de confirmada, criar de novo algo igual é intenção do usuário
    confirm() {
      keys.clear();
    },
  };
};
